import { createSlice } from "@reduxjs/toolkit";

const practitionerRoleSlice = createSlice({
    name: "practitionerRoles",
    initialState: {},
    reducers: {
        registerPractitionerRole: (state, action) => {
            const role = action.payload;

            if (!role?.id) return;

            // Only add if not already present
            if (!state[role.id]) {
                state[role.id] = role;
            } else {
                console.warn(
                    `⚠️ PractitionerRole ${role.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterPractitionerRoles: (state, action) => {
            action.payload.forEach((role) => {
                if (!role?.id) return;

                if (!state[role.id]) {
                    state[role.id] = role;
                } else {
                    console.warn(
                        `⚠️ PractitionerRole ${role.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerPractitionerRole,
    bulkRegisterPractitionerRoles
} = practitionerRoleSlice.actions;

export default practitionerRoleSlice.reducer;
